function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1912(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 29.49,
    height: 17.51,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.18875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.745,
    y: 8.755
  }, "\n        McIntosh\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 17.51,
    width: 29.49,
    height: 17.51,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.501428571428572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.745,
    y: 26.265
  }, "\n        Quitman\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 35.02,
    width: 29.49,
    height: 19.43,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.775714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.745,
    y: 44.735
  }, "\n        Webster\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 54.45,
    width: 29.49,
    height: 20.25,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.745,
    y: 64.575
  }, "\n        Echols\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 74.69,
    width: 29.49,
    height: 20.38,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.5676923076923077
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.745,
    y: 84.88
  }, "\n        Chattahoochee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 95.08,
    width: 29.49,
    height: 24.08,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.01
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.745,
    y: 107.12
  }, "\n        Glascock\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 119.15,
    width: 29.49,
    height: 26.27,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.254
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.745,
    y: 132.285
  }, "\n        Baker\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 145.42,
    width: 29.49,
    height: 30.51,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.915
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.745,
    y: 160.67499999999998
  }, "\n        Camden\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 175.92,
    width: 29.49,
    height: 30.51,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.68625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.745,
    y: 191.17499999999998
  }, "\n        Charlton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 206.43,
    width: 29.49,
    height: 30.78,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.83
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.745,
    y: 221.82
  }, "\n        Lee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 237.21,
    width: 29.49,
    height: 32.28,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.915
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.745,
    y: 253.35000000000002
  }, "\n        Schley\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 269.49,
    width: 29.49,
    height: 34.88,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.68625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.745,
    y: 286.93
  }, "\n        Crawford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 304.38,
    width: 29.49,
    height: 35.02,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.915
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.745,
    y: 321.89
  }, "\n        Miller\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 339.4,
    width: 29.49,
    height: 36.39,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.68625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.745,
    y: 357.59499999999997
  }, "\n        Columbia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 375.79,
    width: 29.49,
    height: 37.35,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.898
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.745,
    y: 394.46500000000003
  }, "\n        White\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 413.13,
    width: 29.49,
    height: 37.48,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.898
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.745,
    y: 431.87
  }, "\n        Bryan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 450.62,
    width: 29.49,
    height: 38.17,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.212857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.745,
    y: 469.705
  }, "\n        Lincoln\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 488.78,
    width: 29.49,
    height: 39.53,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.949
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.745,
    y: 508.54499999999996
  }, "\n        Taliaferro\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 528.32,
    width: 29.49,
    height: 41.18,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.915
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.745,
    y: 548.9100000000001
  }, "\n        Marion\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 569.49,
    width: 29.49,
    height: 42,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.212857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.745,
    y: 590.49
  }, "\n        Jenkins\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 611.49,
    width: 29.49,
    height: 44.19,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.915
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.745,
    y: 633.585
  }, "\n        Twiggs\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 655.68,
    width: 29.49,
    height: 44.32,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.3725
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.745,
    y: 677.8399999999999
  }, "\n        Dade\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.49,
    y: 0,
    width: 35.23,
    height: 38.82,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.032857142857142
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 47.105,
    y: 19.41
  }, "\n        Calhoun\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 64.72,
    y: 0,
    width: 35.23,
    height: 38.82,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.5229999999999997
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 82.335,
    y: 19.41
  }, "\n        Jeff_Davis\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 99.95,
    y: 0,
    width: 35.33,
    height: 38.82,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.888333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 117.61500000000001,
    y: 19.41
  }, "\n        Clinch\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 135.28,
    y: 0,
    width: 35.44,
    height: 38.82,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.906666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 153,
    y: 19.41
  }, "\n        Warren\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 170.72,
    y: 0,
    width: 37.1,
    height: 38.82,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.3
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 189.27,
    y: 19.41
  }, "\n        Liberty\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 207.82,
    y: 0,
    width: 37.2,
    height: 38.82,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.2
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 226.42,
    y: 19.41
  }, "\n        Dawson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 245.02,
    y: 0,
    width: 37.2,
    height: 38.82,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.133333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 263.62,
    y: 19.41
  }, "\n        Effingham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 282.23,
    y: 0,
    width: 37.62,
    height: 38.82,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.18
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 301.04,
    y: 19.41
  }, "\n        Wilkinson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 319.85,
    y: 0,
    width: 40.22,
    height: 38.82,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.8525
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 339.96000000000004,
    y: 19.41
  }, "\n        McDuffie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 360.07,
    y: 0,
    width: 40.43,
    height: 38.82,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.47
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 380.28499999999997,
    y: 19.41
  }, "\n        Oconee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 400.49,
    y: 0,
    width: 40.95,
    height: 38.82,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.705
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 420.96500000000003,
    y: 19.41
  }, "\n        Clay\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 441.44,
    y: 0,
    width: 41.57,
    height: 38.82,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.545714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 462.225,
    y: 19.41
  }, "\n        Johnson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 483.01,
    y: 0,
    width: 41.78,
    height: 38.82,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.764
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 503.9,
    y: 19.41
  }, "\n        Heard\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 524.79,
    y: 0,
    width: 42.92,
    height: 38.82,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.545714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 546.25,
    y: 19.41
  }, "\n        Forsyth\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 567.71,
    y: 0,
    width: 43.96,
    height: 38.82,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.47
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 589.69,
    y: 19.41
  }, "\n        Toombs\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 611.67,
    y: 0,
    width: 43.96,
    height: 38.82,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.764
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 633.65,
    y: 19.41
  }, "\n        Wayne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 655.62,
    y: 0,
    width: 44.38,
    height: 38.82,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.545714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 677.8100000000001,
    y: 19.41
  }, "\n        Lumpkin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.49,
    y: 38.82,
    width: 44.03,
    height: 40.68,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.78
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.504999999999995,
    y: 59.16
  }, "\n        Milton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.49,
    y: 79.5,
    width: 44.03,
    height: 41.78,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.356
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.504999999999995,
    y: 100.39
  }, "\n        Jones\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.49,
    y: 121.28,
    width: 44.03,
    height: 41.87,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.978333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.504999999999995,
    y: 142.215
  }, "\n        Taylor\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.49,
    y: 163.15,
    width: 44.03,
    height: 42.06,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.412
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.504999999999995,
    y: 184.18
  }, "\n        Rabun\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.49,
    y: 205.21,
    width: 44.03,
    height: 43.43,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.204285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.504999999999995,
    y: 226.925
  }, "\n        Catoosa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.49,
    y: 248.64,
    width: 44.03,
    height: 43.61,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.2683333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.504999999999995,
    y: 270.445
  }, "\n        Putnam\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.49,
    y: 292.26,
    width: 44.03,
    height: 43.61,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.2299999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.504999999999995,
    y: 314.065
  }, "\n        Stewart\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.49,
    y: 335.87,
    width: 44.03,
    height: 43.8,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.257142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.504999999999995,
    y: 357.77
  }, "\n        Fayette\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.49,
    y: 379.67,
    width: 44.03,
    height: 43.98,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.796
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.504999999999995,
    y: 401.66
  }, "\n        Irwin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.49,
    y: 423.65,
    width: 44.03,
    height: 44.44,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.806000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.504999999999995,
    y: 445.87
  }, "\n        Burke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.49,
    y: 468.09,
    width: 44.03,
    height: 44.44,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.50375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.504999999999995,
    y: 490.30999999999995
  }, "\n        Stephens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.49,
    y: 512.53,
    width: 44.03,
    height: 46.36,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.806000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.504999999999995,
    y: 535.7099999999999
  }, "\n        Banks\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.49,
    y: 558.89,
    width: 44.03,
    height: 46.36,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.50375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.504999999999995,
    y: 582.0699999999999
  }, "\n        Rockdale\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.49,
    y: 605.26,
    width: 44.03,
    height: 47.19,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.806000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.504999999999995,
    y: 628.855
  }, "\n        Macon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.49,
    y: 652.45,
    width: 44.03,
    height: 47.55,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.338333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.504999999999995,
    y: 676.225
  }, "\n        Turner\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 73.51,
    y: 38.82,
    width: 45.11,
    height: 47.3,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.022
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 96.065,
    y: 62.47
  }, "\n        Towns\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 118.63,
    y: 38.82,
    width: 45.29,
    height: 47.3,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.058
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 141.275,
    y: 62.47
  }, "\n        Glynn\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 163.91,
    y: 38.82,
    width: 46.14,
    height: 47.3,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.69
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 186.98,
    y: 62.47
  }, "\n        Talbot\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 210.05,
    y: 38.82,
    width: 47.16,
    height: 47.3,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.895
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 233.63,
    y: 62.47
  }, "\n        Campbell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 257.21,
    y: 38.82,
    width: 47.76,
    height: 47.3,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.757142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 281.09,
    y: 62.47
  }, "\n        Clayton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 304.97,
    y: 38.82,
    width: 48.61,
    height: 47.3,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.459999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 329.27500000000003,
    y: 62.47
  }, "\n        Butts\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 353.58,
    y: 38.82,
    width: 48.61,
    height: 47.3,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.883333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 377.885,
    y: 62.47
  }, "\n        Wilcox\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 402.19,
    y: 38.82,
    width: 48.7,
    height: 47.3,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.459999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 426.54,
    y: 62.47
  }, "\n        Early\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 62,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 450.89,
    y: 38.82,
    width: 48.87,
    height: 47.3,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.459999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 475.325,
    y: 62.47
  }, "\n        Grady\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 63,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 499.76,
    y: 38.82,
    width: 49.38,
    height: 47.3,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.2555555555555555
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 524.45,
    y: 62.47
  }, "\n        Jefferson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 64,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 549.13,
    y: 38.82,
    width: 50.15,
    height: 47.3,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.883333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 574.205,
    y: 62.47
  }, "\n        Pierce\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 65,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 599.28,
    y: 38.82,
    width: 50.32,
    height: 47.3,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.459999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 624.4399999999999,
    y: 62.47
  }, "\n        Upson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 66,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 649.6,
    y: 38.82,
    width: 50.4,
    height: 47.3,
    style: {
      fill: "#D4FFD4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.757142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 674.8000000000001,
    y: 62.47
  }, "\n        Douglas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 67,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 73.51,
    y: 86.12,
    width: 50.03,
    height: 47.9,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.58
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 98.525,
    y: 110.07000000000001
  }, "\n        Worth\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 68,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 73.51,
    y: 134.01,
    width: 50.03,
    height: 48.38,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.911428571428572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 98.525,
    y: 158.2
  }, "\n        Hancock\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 69,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 73.51,
    y: 182.4,
    width: 50.03,
    height: 49.59,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.9590000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 98.525,
    y: 207.195
  }, "\n        Oglethorpe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 70,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 73.51,
    y: 231.99,
    width: 50.03,
    height: 49.83,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.305
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 98.525,
    y: 256.90500000000003
  }, "\n        Harris\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 71,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 73.51,
    y: 281.82,
    width: 50.03,
    height: 50.08,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.147142857142858
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 98.525,
    y: 306.86
  }, "\n        Screven\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 72,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 73.51,
    y: 331.9,
    width: 50.03,
    height: 51.45,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.147142857142858
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 98.525,
    y: 357.625
  }, "\n        Appling\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 73,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 73.51,
    y: 383.34,
    width: 50.03,
    height: 52.09,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.006
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 98.525,
    y: 409.385
  }, "\n        Dooly\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 74,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 73.51,
    y: 435.43,
    width: 50.03,
    height: 52.57,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.5075
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 98.525,
    y: 461.71500000000003
  }, "\n        Tift\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 75,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 73.51,
    y: 488.01,
    width: 50.03,
    height: 52.9,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.338333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 98.525,
    y: 514.46
  }, "\n        Morgan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 76,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 73.51,
    y: 540.9,
    width: 50.03,
    height: 52.9,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.147142857142858
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 98.525,
    y: 567.35
  }, "\n        Terrell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 77,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 73.51,
    y: 593.8,
    width: 50.03,
    height: 52.98,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.338333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 98.525,
    y: 620.29
  }, "\n        Gilmer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 78,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 73.51,
    y: 646.78,
    width: 50.03,
    height: 53.22,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.25375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 98.525,
    y: 673.39
  }, "\n        Randolph\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 79,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 123.54,
    y: 86.12,
    width: 49.09,
    height: 54.48,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.818000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 148.085,
    y: 113.36
  }, "\n        Union\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 80,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 172.63,
    y: 86.12,
    width: 49.16,
    height: 54.48,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.193333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 197.20999999999998,
    y: 113.36
  }, "\n        Jasper\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 81,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 221.79,
    y: 86.12,
    width: 50.2,
    height: 54.48,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.040000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 246.89,
    y: 113.36
  }, "\n        Henry\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 82,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 271.99,
    y: 86.12,
    width: 50.72,
    height: 54.48,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.453333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 297.35,
    y: 113.36
  }, "\n        Greene\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 83,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 322.7,
    y: 86.12,
    width: 51.23,
    height: 54.48,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.3185714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 348.315,
    y: 113.36
  }, "\n        Baldwin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 84,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 373.94,
    y: 86.12,
    width: 51.9,
    height: 54.48,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.379999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 399.89,
    y: 113.36
  }, "\n        Crisp\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 85,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 425.84,
    y: 86.12,
    width: 53.53,
    height: 54.48,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.647142857142858
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 452.60499999999996,
    y: 113.36
  }, "\n        Madison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 86,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 479.37,
    y: 86.12,
    width: 54.34,
    height: 54.48,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.762857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 506.54,
    y: 113.36
  }, "\n        Telfair\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 87,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 533.71,
    y: 86.12,
    width: 54.42,
    height: 54.48,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.07
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 560.9200000000001,
    y: 113.36
  }, "\n        Wilkes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 88,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 588.13,
    y: 86.12,
    width: 54.79,
    height: 54.48,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.895999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 615.525,
    y: 113.36
  }, "\n        Dodge\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 89,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 642.92,
    y: 86.12,
    width: 57.08,
    height: 54.48,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.053333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 671.4599999999999,
    y: 113.36
  }, "\n        Dougherty\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 90,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 123.54,
    y: 140.6,
    width: 58.81,
    height: 52.88,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.813333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 152.945,
    y: 167.04
  }, "\n        Murray\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 91,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 123.54,
    y: 193.48,
    width: 58.81,
    height: 53.09,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.848333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 152.945,
    y: 220.02499999999998
  }, "\n        Brooks\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 92,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 123.54,
    y: 246.57,
    width: 58.81,
    height: 54.18,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.545
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 152.945,
    y: 273.65999999999997
  }, "\n        Hart\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 93,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 123.54,
    y: 300.75,
    width: 58.81,
    height: 54.87,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.838571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 152.945,
    y: 328.185
  }, "\n        Houston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 94,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 123.54,
    y: 355.62,
    width: 58.81,
    height: 55.35,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.91875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 152.945,
    y: 383.295
  }, "\n        Spalding\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 95,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 123.54,
    y: 410.97,
    width: 58.81,
    height: 56.1,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.014285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 152.945,
    y: 439.02000000000004
  }, "\n        Berrien\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 96,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 123.54,
    y: 467.08,
    width: 58.81,
    height: 57.06,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.1325
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 152.945,
    y: 495.61
  }, "\n        Ben_Hill\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 97,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 123.54,
    y: 524.14,
    width: 58.81,
    height: 58.09,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.26125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 152.945,
    y: 553.185
  }, "\n        Tattnall\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 98,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 123.54,
    y: 582.24,
    width: 58.81,
    height: 58.23,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.47
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 152.945,
    y: 611.355
  }, "\n        Habersham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 99,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 123.54,
    y: 640.47,
    width: 58.81,
    height: 59.53,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.5344444444444445
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 152.945,
    y: 670.235
  }, "\n        Chattooga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 100,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 182.35,
    y: 140.6,
    width: 61.21,
    height: 57.6,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.22857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 212.95499999999998,
    y: 169.4
  }, "\n        Emanuel\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 101,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 243.57,
    y: 140.6,
    width: 62.19,
    height: 57.6,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.6
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 274.66499999999996,
    y: 169.4
  }, "\n        Monroe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 102,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 305.76,
    y: 140.6,
    width: 64.43,
    height: 57.6,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 14.4
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 337.975,
    y: 169.4
  }, "\n        Pike\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 103,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 370.19,
    y: 140.6,
    width: 64.57,
    height: 57.6,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.22857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 402.475,
    y: 169.4
  }, "\n        Lowndes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 104,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 434.77,
    y: 140.6,
    width: 64.71,
    height: 57.6,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.6
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 467.125,
    y: 169.4
  }, "\n        Fannin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 105,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 499.48,
    y: 140.6,
    width: 65.2,
    height: 57.6,
    style: {
      fill: "#D4FFD4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.22857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 532.08,
    y: 169.4
  }, "\n        Pickens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 106,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 564.69,
    y: 140.6,
    width: 65.91,
    height: 57.6,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.6
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 597.6450000000001,
    y: 169.4
  }, "\n        Newton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 107,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 630.59,
    y: 140.6,
    width: 69.41,
    height: 57.6,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.6
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 665.2950000000001,
    y: 169.4
  }, "\n        DeKalb\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 108,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 182.35,
    y: 198.2,
    width: 66.85,
    height: 60.16,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.594285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 215.77499999999998,
    y: 228.27999999999997
  }, "\n        Bulloch\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 109,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 182.35,
    y: 258.36,
    width: 66.85,
    height: 60.28,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.0280000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 215.77499999999998,
    y: 288.5
  }, "\n        Montgomery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 110,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 182.35,
    y: 318.64,
    width: 66.85,
    height: 60.34,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.034000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 215.77499999999998,
    y: 348.81
  }, "\n        Meriwether\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 111,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 182.35,
    y: 378.98,
    width: 66.85,
    height: 61.85,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.308333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 215.77499999999998,
    y: 409.90500000000003
  }, "\n        Coffee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 112,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 182.35,
    y: 440.83,
    width: 66.85,
    height: 63.36,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.56
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 215.77499999999998,
    y: 472.51
  }, "\n        Sumter\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 113,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 182.35,
    y: 504.19,
    width: 66.85,
    height: 63.42,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.9275
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 215.77499999999998,
    y: 535.9
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 114,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 182.35,
    y: 567.61,
    width: 66.85,
    height: 66.07,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 16.5175
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 215.77499999999998,
    y: 600.645
  }, "\n        Ware\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 115,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 182.35,
    y: 633.68,
    width: 66.85,
    height: 66.32,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.053333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 215.77499999999998,
    y: 666.8399999999999
  }, "\n        Clarke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 116,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 249.2,
    y: 198.2,
    width: 63.26,
    height: 70.53,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.9075
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 280.83,
    y: 233.46499999999997
  }, "\n        Mitchell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 117,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 312.46,
    y: 198.2,
    width: 63.77,
    height: 70.53,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.377000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 344.34499999999997,
    y: 233.46499999999997
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 118,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 376.23,
    y: 198.2,
    width: 64.34,
    height: 70.53,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.723333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 408.40000000000003,
    y: 233.46499999999997
  }, "\n        Coweta\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 119,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 440.57,
    y: 198.2,
    width: 64.34,
    height: 70.53,
    style: {
      fill: "#7FFF7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.0425
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 472.74,
    y: 233.46499999999997
  }, "\n        Haralson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 120,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 504.91,
    y: 198.2,
    width: 64.8,
    height: 70.53,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.799999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 537.3100000000001,
    y: 233.46499999999997
  }, "\n        Elbert\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 121,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 569.71,
    y: 198.2,
    width: 64.97,
    height: 70.53,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.281428571428572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 602.195,
    y: 233.46499999999997
  }, "\n        Pulaski\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 122,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 634.69,
    y: 198.2,
    width: 65.31,
    height: 70.53,
    style: {
      fill: "#7FFF7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.16375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 667.345,
    y: 233.46499999999997
  }, "\n        Paulding\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 123,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 249.2,
    y: 268.73,
    width: 70.2,
    height: 68.9,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.483333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 284.3,
    y: 303.18
  }, "\n        Walton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 124,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 249.2,
    y: 337.63,
    width: 70.2,
    height: 70.62,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.775
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 284.3,
    y: 372.94
  }, "\n        Colquitt\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 125,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 249.2,
    y: 408.25,
    width: 70.2,
    height: 71.37,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.700000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 284.3,
    y: 443.935
  }, "\n        Thomas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 126,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 249.2,
    y: 479.62,
    width: 70.2,
    height: 71.83,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.028571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 284.3,
    y: 515.535
  }, "\n        Laurens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 127,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 249.2,
    y: 551.45,
    width: 70.2,
    height: 73.9,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 17.55
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 284.3,
    y: 588.4000000000001
  }, "\n        Polk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 128,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 249.2,
    y: 625.35,
    width: 70.2,
    height: 74.65,
    style: {
      fill: "#D4FFD4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.700000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 284.3,
    y: 662.6750000000001
  }, "\n        Gordon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 129,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 319.4,
    y: 268.73,
    width: 70.9,
    height: 76.35,
    style: {
      fill: "#D4FFD4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.8625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 354.84999999999997,
    y: 306.90500000000003
  }, "\n        Cherokee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 130,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 390.3,
    y: 268.73,
    width: 72.38,
    height: 76.35,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.042222222222222
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 426.49,
    y: 306.90500000000003
  }, "\n        Whitfield\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 131,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 462.68,
    y: 268.73,
    width: 74.54,
    height: 76.35,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.423333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 499.95,
    y: 306.90500000000003
  }, "\n        Walker\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 132,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 537.23,
    y: 268.73,
    width: 81.04,
    height: 76.35,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 15.27
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 577.75,
    y: 306.90500000000003
  }, "\n        Troup\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 133,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 618.27,
    y: 268.73,
    width: 81.73,
    height: 76.35,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 19.0875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 659.135,
    y: 306.90500000000003
  }, "\n        Hall\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 134,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 319.4,
    y: 345.08,
    width: 75.41,
    height: 86.5,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.772857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 357.10499999999996,
    y: 388.33
  }, "\n        Decatur\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 135,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 319.4,
    y: 431.58,
    width: 75.41,
    height: 87.89,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.42625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 357.10499999999996,
    y: 475.525
  }, "\n        Gwinnett\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 136,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 319.4,
    y: 519.47,
    width: 75.41,
    height: 89.38,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.568333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 357.10499999999996,
    y: 564.1600000000001
  }, "\n        Bartow\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 137,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 319.4,
    y: 608.85,
    width: 75.41,
    height: 91.15,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.772857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 357.10499999999996,
    y: 654.4250000000001
  }, "\n        Jackson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 138,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 394.82,
    y: 345.08,
    width: 89.67,
    height: 77.38,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.054285714285713
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 439.655,
    y: 383.77
  }, "\n        Carroll\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 139,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 484.48,
    y: 345.08,
    width: 104.53,
    height: 77.38,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 19.345
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 536.745,
    y: 383.77
  }, "\n        Cobb\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 140,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 589.01,
    y: 345.08,
    width: 110.99,
    height: 77.38,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.6725
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 644.505,
    y: 383.77
  }, "\n        Muscogee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 141,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 394.82,
    y: 422.46,
    width: 108.44,
    height: 84.63,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 16.926
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 449.03999999999996,
    y: 464.775
  }, "\n        Floyd\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 142,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 394.82,
    y: 507.09,
    width: 108.44,
    height: 89.87,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.23375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 449.03999999999996,
    y: 552.025
  }, "\n        Richmond\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 143,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 394.82,
    y: 596.96,
    width: 108.44,
    height: 103.04,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 25.76
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 449.03999999999996,
    y: 648.48
  }, "\n        Bibb\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 144,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 503.26,
    y: 422.46,
    width: 196.74,
    height: 79.57,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.367142857142856
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 601.63,
    y: 462.245
  }, "\n        Chatham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 145,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 503.26,
    y: 502.04,
    width: 196.74,
    height: 197.96,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 32.79
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 601.63,
    y: 601.02
  }, "\n        Fulton\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1912);
export default __webpack_public_path__ + "static/media/1912.718e8e6d50167410e84fdac43ffdaf8a.svg";
export { ForwardRef as ReactComponent };